import { render, staticRenderFns } from "./ChooseClientPortfolioForm.vue?vue&type=template&id=f50ac4f6"
import script from "./ChooseClientPortfolioForm.vue?vue&type=script&lang=js"
export * from "./ChooseClientPortfolioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports